import React from 'react';
import uploadAttachmentHandler from './UploadAttachmentHandler';

/**
 * Description and provider panel for the currently selected file.
 * Locked during upload — inputs disabled.
 * @param {UploadFileItem} item - currently selected file item
 * @param {number} index - index of selected item in files array
 * @param {string[]} providers - available storage provider keys
 * @param {boolean} locked - true during upload
 */
export default function UploadFilePanel({ item, index, providers, locked }) {
    /**
     * Persists description change to the file item via handler.
     * @param {React.ChangeEvent<HTMLTextAreaElement>} e
     */
    const handleDescriptionChange = (e) => {
        uploadAttachmentHandler.dispatch('onDescriptionChanged', { index, value: e.target.value });
    };

    /**
     * Persists provider change to the file item via handler.
     * @param {React.ChangeEvent<HTMLSelectElement>} e
     */
    const handleProviderChange = (e) => {
        uploadAttachmentHandler.dispatch('onProviderChanged', { index, value: e.target.value });
    };

    return (
        <div id="upload-file-form" className="upload-file-form">
            <textarea
                id="upload-dlg-description"
                className="upload-dlg-textarea"
                placeholder="Description (optional)"
                maxLength={400}
                value={item.description}
                disabled={locked}
                onChange={handleDescriptionChange}
            />

            <select
                id="upload-dlg-provider"
                className="upload-dlg-select"
                value={item.provider}
                disabled={locked}
                onChange={handleProviderChange}
            >
                {providers.map((p) => (
                    <option key={p} value={p}>
                        {p}
                    </option>
                ))}
            </select>
        </div>
    );
}
